import omit from 'lodash/omit';
import {
  AddressDTO,
  InsuranceDTO,
  PatientDTO,
} from '@/dtos';
import dayjs, {
  Dayjs,
} from 'utils/dayjs';

export function getPatientDemographics({
  firstName,
  middleName,
  lastName,
  genderDescription,
  dateOfBirth,
}: Partial<PatientDTO>) {
  return {
    firstName,
    middleName,
    lastName,
    genderDescription,
    dateOfBirth: dayjs(dateOfBirth ?? ''),
  };
}

export type Insurance = Partial<Omit<InsuranceDTO, 'insuranceDOB'>>
 & { insuranceDOB?: Dayjs };
export function getDemographicsFromInsurance({
  insuranceOwnerFirstName: firstName,
  insuranceOwnerMiddleName: middleName,
  insuranceOwnerLastName: lastName,
  insuranceOwnerDOB: dateOfBirth,
  insuranceOwnerGenderDescription: genderDescription,
}: Insurance) {
  return {
    firstName,
    middleName,
    lastName,
    genderDescription,
    dateOfBirth,
  };
}

export function getPatientAddress(address: Partial<AddressDTO>) {
  return omit(address, ['nickName', 'serviceFacilityName', 'serviceFacilityNpi']);
}
